import { useContext } from "react";
import { AppContext } from "../App";
import { CDN_URL } from "../Helpers";
import { MdArrowOutward, MdSchedule } from "react-icons/md";

export default function OneNews({ data }) {
  const appContext = useContext(AppContext);

  const primaryDate =
    data?.publish_date ||
    data?.published_at ||
    data?.date ||
    (data?.dateCreated ? data.dateCreated * 1000 : null);

  const dateObj = primaryDate ? new Date(primaryDate) : null;
  const dateLabel = dateObj
    ? dateObj.toLocaleDateString(undefined, {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "Recent";

  function view() {
    appContext.navTo({
      item: "view",
      subItem: "news",
      extraItem: data.uuid,
    });
  }

  return (
    <article
      className="news-card h-100"
      role="button"
      tabIndex={0}
      onClick={view}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") view();
      }}
    >
      <div
        className="news-media"
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.05), rgba(0,0,0,0.4)), url(${CDN_URL + data.coverPhoto})`,
        }}
      >
        <div className="news-date-chip">
          <MdSchedule size={16} className="me-1" />
          {dateLabel}
        </div>
      </div>
      <div className="news-body">
        <h6 className="font-bold mb-2 news-title">{data.title}</h6>
        {data?.summary ? (
          <p className="news-summary mb-3">{data.summary}</p>
        ) : null}
        <div className="d-flex align-items-center justify-content-between">
          <span className="news-tag">News</span>
          <span className="news-readmore">
            Read more <MdArrowOutward size={18} />
          </span>
        </div>
      </div>
    </article>
  );
}
